/* eslint-disable */
import a11 from './a11.js'
import o11 from './o11.js'

var c11 = {
  merge: function i() {
    for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    var r = a11(t);
    if (r.length < 1)
      return {};
    if (1 === r.length)
      return t[0];
    return r.reduce(function (t, n) {
      return Object.keys(n).forEach(function (e) {
        "object" === o11(t[e]) && "object" === o11(n[e]) && void 0 === n[e].length ? t[e] = i(t[e], n[e]) : t[e] = n[e]
      }),
        t
    }, {})
  }
}

export default c11
